import {BrowserRouter as Router} from "react-router-dom";
import Routes from "./Routes";
import ScrollToTop from "../components/scroll/ScrollToTop";
import {PUBLIC_BASE_PATH} from "../shared/env";
import AcessoAplicacao from "./AcessoAplicacao";

function App() {
    return (
        <Router basename={PUBLIC_BASE_PATH || undefined}>
            <ScrollToTop />
            <AcessoAplicacao>
                <Routes />
            </AcessoAplicacao>
        </Router>
    );
}

export default App;
